import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";

import type { APIResponse, MatterIntakeTemplateQuestion } from "@/lib/types";

type MatterIntakeTemplateQuestionInput = Pick<
  MatterIntakeTemplateQuestion,
  "templateId" | "label" | "type"
> &
  Partial<
    Pick<MatterIntakeTemplateQuestion, "options" | "order" | "dateModified">
  >;

const questionPayloadKeys = [
  "templateId",
  "label",
  "type",
  "options",
  "order",
] as const;

const getQuestionPayload = (data: MatterIntakeTemplateQuestionInput) =>
  Object.fromEntries(
    questionPayloadKeys
      .filter((key) => key in data)
      .map((key) => [key, data[key]]),
  );

export const retrieveMatterIntakeTemplateQuestions = async (
  templateId?: string,
) => {
  return authenticatedFastApiAxiosInstance
    .get<
      APIResponse<MatterIntakeTemplateQuestion[]>
    >(`${baseFastApiMatterRoute}/intake-templates/${templateId}/questions`)
    .then((res) => res.data);
};

export const createMatterIntakeTemplateQuestion = async (
  data: MatterIntakeTemplateQuestionInput,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterIntakeTemplateQuestion>
    >(`${baseFastApiMatterRoute}/intake-templates/questions`, getQuestionPayload(data))
    .then((res) => res.data);
};

export const updateMatterIntakeTemplateQuestion = async (
  data: MatterIntakeTemplateQuestionInput &
    Pick<MatterIntakeTemplateQuestion, "id">,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<MatterIntakeTemplateQuestion>>(
      `${baseFastApiMatterRoute}/intake-templates/questions`,
      {
        ...getQuestionPayload(data),
        id: data.id,
      },
    )
    .then((res) => res.data);
};

export const deleteMatterIntakeTemplateQuestion = async (data: {
  id: string;
  templateId: string;
}) => {
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterIntakeTemplateQuestion>
    >(`${baseFastApiMatterRoute}/intake-templates/${data.templateId}/questions/${data.id}`)
    .then((res) => res.data);
};
